import { render, staticRenderFns } from "./editcity.vue?vue&type=template&id=d72f66f0&"
import script from "./editcity.vue?vue&type=script&lang=ts&"
export * from "./editcity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editcity.vue"
export default component.exports